export default {
  "allowList": [
    "r", "action", "step", "show", "service", "service_product"
  ]
}
